import {SnackbarProvider} from 'notistack';
import ActionButton from './ActionButton';

const Provider = ({children}) => {
  return (
    <SnackbarProvider
      anchorOrigin={{vertical: 'top', horizontal: 'right'}}
      autoHideDuration={4000}
      action={(key) => <ActionButton buttonId={key} />}
    >
      {children}
    </SnackbarProvider>
  );
}

;

export default Provider;
